<template>
  <div class="row bg-secondary pr-3">
    <modal
      name="modal-search-box"
      width="80%"
      height="auto"
      style="overflow-y: scroll"
    >
      <user-search-box class="pl-3 pr-3"></user-search-box>
    </modal>
    <div class="col-12">
      <div class="row">
        <Button
          class="btn bg-primary text-white btn-lg btn-block rounded mb-3 ml-3 d-xl-none"
          type="button"
          @click="$modal.show(`modal-search-box`)"
        >
          <i class="fa fa-search"></i> <i class="fa fa-user pr-3"></i>
          Mitgliedersuche
        </Button>
      </div>
      <div class="row">
        <div
          class="col-12 col-sm-6 col-md-4"
          v-for="(profile, index) in results"
          :key="index"
        >
          <user-short-info
            :mark="mark"
            :displayErotic="displayErotic"
            :newMemberColor="displayNewMembersColor"
            :displayNewMembers="displayNewMembers"
            :id="'Profile-' + index"
            :profile="profile"
            class="pl-3 pb-3"
          ></user-short-info>
        </div>

        <div v-if="!hasResults" class="col-12 text-center">
          Keine Profile gefunden starten Sie die Suche erneut.
        </div>
      </div>
      <div v-if="hasResults && loading" class="row">
        <div class="col-12" align="center">
          <i class="text-primary fas fa-spinner fa-spin fa-10x"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      requestedResults: 0,
      bottom: false,
      loading: false,
      take: 0
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.bottom = this.bottomVisible();
    });
    this.take = this.filter.take;
    this.updateResults(localStorage.getItem("result-lenghts"));
  },
  created() {
    window.addEventListener("beforeunload", this.handler);
  },
  computed: {
    displayErotic() {
      return Laravel.displayErotic;
    },
    displayNewMembers() {
      return Laravel.displayNewMembers;
    },
    displayNewMembersColor() {
      return Laravel.displayNewMembersColor;
    },
    mark() {
      return Laravel.mark;
    },
    hasResults() {
      return this.results !== null && this.results.length > 0;
    },
    filter() {
      return this.$store.getters["search/filter"];
    },
    results() {
      return this.$store.getters["search/result"];
    }
  },
  watch: {
    bottom(bottom) {
      if (bottom && !this.loading) this.updateResults();
    }
  },
  methods: {
    handler() {
      localStorage.setItem("result-lenghts", this.results.length);
    },
    updateResults(take) {
      if (this.$store.getters["search/filterprop"]("postcode")) {
        let filter = {};
        Object.assign(filter, this.filter);
        filter.take = take || this.take;
        this.requestedResults = this.results.length + filter.take;
        filter.skip = this.results.length;
        this.loading = true;
        this.$store
          .dispatch("search/search", filter)
          .then(() => {
            if (this.requestedResults > this.results.length)
              this.loading = false;
          })
          .finally(() => {
            this.loading = false;
            if (
              localStorage.getItem("last-id") &&
              document.getElementById(localStorage.getItem("last-id"))
            ) {
              document
                .getElementById(localStorage.getItem("last-id"))
                .scrollIntoView();
              localStorage.removeItem("last-id");
            }
          });
        if (this.bottomVisible && !this.loading)
          this.bottom = this.bottomVisible();
      }
    },
    bottomVisible() {
      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight - 100;
      return bottomOfPage || pageHeight < visible;
    }
  }
};
</script>
